// extracted by mini-css-extract-plugin
module.exports = {"underlineBlack":"underline_underlineBlack__2bU-e","underlineWhite":"underline_underlineWhite__3t6Zq"};